import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import { IUser } from "interfaces/user";
import { theme } from "style/theme";

interface UserAvatarProps {
  user: IUser;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user }) => {
  // Generate initials from name
  const getInitials = (name: string) => {
    if (!name) return "?";
    const nameParts = name.split(" ");
    if (nameParts.length >= 2) {
      return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };
  return (
    <Box display="flex" alignItems="center">
      <Avatar
        sx={{
          width: 28,
          height: 28,
          mr: 1.5,
          fontSize: "0.75rem",
          bgcolor: theme.palette.primary.main,
        }}
      >
        {getInitials(user.firstName + " " + user.lastName)}
      </Avatar>
      <Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            lineHeight: 1.3,
          }}
        >
          {user.firstName} {user.lastName}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserAvatar;
